import React, { useState } from 'react';
import { CLIENT_CITY } from '../../../configurations';

function DownloadCDS() {

  const [isLoadingPolicy, setIsLoadingPolicy] = useState(false);
  const [isLoadingRules, setIsLoadingRules] = useState(false);

  const handleDownload = async (fileType) => {

    if (fileType === 'curb_policy') {
        setIsLoadingPolicy(true);
    } else if (fileType === 'curb_zone') {
        setIsLoadingRules(true);
    }

    try {

      const response = await fetch(`https://cs0ndcoknh.execute-api.us-west-2.amazonaws.com/GenerateDownloadLinkCDS?city=${CLIENT_CITY}&file_type=${fileType}`);

      const data = await response.json();
      const url = data.url;

      // Create a temporary anchor element to trigger the download
      const a = document.createElement('a');
      a.href = url;
      a.download = 'filename.json';  // The filename you want to use
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

    } catch (error) {
      if (error.message === 'File not found.') {
        alert('The requested file does not exist. Please check the file type or try again later.');
      } else {
        console.error('Error downloading the file:', error);
        alert('We encountered an issue while processing your request. Please try again later.');
      }

    } finally {
      setIsLoadingPolicy(false);
      setIsLoadingRules(false);
    }
  };

  return (
    <div className="bg-gray-50 px-2 py-1 text-sm text-gray-800 dark:bg-gray-700/50 dark:text-gray-400 mt-5">
      <h2 className="text-lg font-semibold mb-2">Download CDS Files</h2>

      <button
        onClick={() => handleDownload('curb_policy')}
        disabled={isLoadingPolicy}
        className={`inline-flex w-full items-center justify-center space-x-2 rounded-lg border border-teal-700 bg-teal-700 px-6 py-2 font-semibold leading-6 text-white hover:border-primary-600 hover:bg-primary-600 hover:text-white focus:ring focus:ring-primary-400 focus:ring-opacity-50 active:border-primary-700 active:bg-primary-700 dark:focus:ring-primary-400 dark:focus:ring-opacity-90 
          ${isLoadingPolicy ? 'cursor-not-allowed bg-gray-300 text-gray-600' : ''}`}
      >
        {isLoadingPolicy ? <>Loading...</> : <>Download Curb Policy</>}
      </button>
      <div style={{ marginBottom: 5 }} />
      <button
        onClick={() => handleDownload('curb_zone')}
        disabled={isLoadingRules}
        className={`inline-flex w-full items-center justify-center space-x-2 rounded-lg border border-teal-700 bg-teal-700 px-6 py-2 font-semibold leading-6 text-white hover:border-primary-600 hover:bg-primary-600 hover:text-white focus:ring focus:ring-primary-400 focus:ring-opacity-50 active:border-primary-700 active:bg-primary-700 dark:focus:ring-primary-400 dark:focus:ring-opacity-90 
          ${isLoadingRules ? 'cursor-not-allowed bg-gray-300 text-gray-600' : ''}`}
      >
        {isLoadingRules ? <>Loading...</> : <>Download Curb Zones</>}
      </button>
    </div>
  );
}

export default DownloadCDS;
